import React from 'react';
import './ModalNewUser.css'

const ModalDeleteUser = ({show, setShow, user, delOneUser}) => {


    return (
        <div className={show ? "modal active" : "modal"} onClick={() => setShow(false)}>
            <div className={show ? "modal__content active" : "modal__content"} onClick={e => e.stopPropagation()}>

                <h2>Хотите удалить этого пользователя?</h2>
                <div className="user__del_btn__block">
                    <button className='btn__yes' onClick={() => delOneUser(user)}>Да</button>
                    <button className='btn__no' onClick={() => setShow(false)}>Нет</button>
                </div>


            </div>
        </div>
    );
};

export default ModalDeleteUser;